import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Form, Row, Button, Alert } from "reactstrap";

export const Contact = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Por ahora usa Mailchimp, pero podrías cambiar esto
    // para usar la misma lógica que el modal de newsletter
    try {
      // Enviar a Mailchimp
      const form = e.target;
      form.submit();
      
      setAlertMessage(t("¡Gracias por suscribirte! Revisa tu correo."));
      setShowAlert(true);
      setEmail("");
      
      setTimeout(() => {
        setShowAlert(false);
      }, 5000);
    } catch (error) {
      setAlertMessage(t("Error al suscribir. Intenta de nuevo."));
      setShowAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="section py-5" id="contact" style={{
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)'
    }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="text-center mb-5">
              <h2 className="text-white mb-3">
                {t("Mantente Conectado")}
              </h2>
              <p className="text-white-50 lead">
                {t("No te pierdas ninguna actualización del CEC 2026")}
              </p>
            </div>

            {/* Newsletter Form */}
            <div className="newsletter-box p-4" style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '15px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <h4 className="text-white text-center mb-4">
                {t("Suscríbete a nuestro boletín")}
              </h4>
              
              {showAlert && (
                <Alert color={alertMessage.includes('Error') ? 'danger' : 'success'} className="mb-3">
                  {alertMessage}
                </Alert>
              )}

              <Form
                method="post"
                action="https://cecspace.us21.list-manage.com/subscribe/post?u=c75d808c27544f8648a08c4b1&amp;id=13744f88a0&amp;f_id=0034f8e6f0"
                name="contact-form"
                onSubmit={handleSubmit}
                className="newsletter-form"
              >
                <div className="d-flex gap-2">
                  <input
                    type="email"
                    name="EMAIL"
                    className="form-control form-control-lg"
                    placeholder={t("tu@email.com")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      color: 'white'
                    }}
                  />
                  <Button 
                    className="btn btn-primary btn-lg px-4"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? t("Enviando...") : t("Suscribirse")}
                  </Button>
                </div>
              </Form>
              
              <p className="text-white-50 text-center mt-3 mb-0 small">
                {t("Respetamos tu privacidad. Puedes cancelar tu suscripción en cualquier momento.")}
              </p>
            </div>

            {/* Redes Sociales */}
            <div className="text-center mt-5">
              <h5 className="text-white mb-3">{t("Síguenos en redes sociales")}</h5>
              <div className="social-links d-flex justify-content-center gap-3">
                <a 
                  href="https://facebook.com/cecspace" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  style={{
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '50%',
                    color: 'white',
                    fontSize: '1.5rem',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = '#1877f2';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  📘
                </a>
                <a 
                  href="https://twitter.com/cecspace" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  style={{
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '50%',
                    color: 'white',
                    fontSize: '1.5rem',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = '#1da1f2';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  🐦
                </a>
                <a 
                  href="https://instagram.com/cecspace" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  style={{
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '50%',
                    color: 'white',
                    fontSize: '1.5rem',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  📷
                </a>
                <a 
                  href="https://linkedin.com/company/cecspace" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  style={{
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '50%',
                    color: 'white',
                    fontSize: '1.5rem',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = '#0077b5';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  💼
                </a>
              </div>
            </div>

            {/* Información de contacto */}
            <div className="text-center mt-5 pt-4">
              <p className="text-white-50 mb-2">
                {t("¿Tienes preguntas? Escríbenos a:")}
              </p>
              <a 
                href="mailto:info@cecguatemala2026.org" 
                className="text-white h5"
                style={{ textDecoration: 'none' }}
              >
                info@cecguatemala2026.org
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};